// Import the functions you need from the SDKs you needimport firebase from "firebase";

import firebase from "firebase";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAw0Dd6dksEMUSWU6aknVoEoO85NXFrz5E",
  authDomain: "wave-admin-panel.firebaseapp.com",
  projectId: "wave-admin-panel",
  storageBucket: "wave-admin-panel.appspot.com",
  messagingSenderId: "698412212553",
  appId: "1:698412212553:web:c9a67f6fec0a37d71afa98",
  measurementId: "G-02FGDG143R"
};

// Initialize Firebase



const fire = firebase.initializeApp(firebaseConfig);
export default fire